import { FunctionComponent } from 'react';

export const WidgetBackground: FunctionComponent = () => {
  return <img className="h-screen w-full object-cover" src="/images/widget_backgrounds/background_negative.png" />;
};
